<template>
<div>
  <div v-if="!$auth.getMyUser().client_infos[0].isContractSigned">
    <h6 style="text-align: center;margin-top: 30px; font-style: italic;">{{$ml.get('cdncontractsigned')}}</h6>
  </div>
  <div v-if="$auth.getMyUser().client_infos[0].isContractSigned">
    <div class="d-flex justify-content-center mb-3 marginaltopsm" v-if="isLoading">
        <b-spinner label="Loading..."></b-spinner>
    </div>
    <b-row class="justify-content-around align-items-center marginaltop" v-if="cdns.length > 0" style="text-align: center;">
      <b-col md="4"  cols="3">
        <strong>{{$ml.get('originurl')}}</strong>
      </b-col>
      <b-col md="4"  cols="3">
        <strong>{{$ml.get('newurl')}}</strong>
      </b-col>
      <b-col cols="2">
        <strong>{{$ml.get('cdnprice')}}</strong>
      </b-col>
      <b-col md="2" cols="4">
          <strong>{{$ml.get('actions')}}</strong>
      </b-col>

    </b-row>
      <hr>
  <div v-for="(cdn, idx) in cdns" v-bind:key="idx" style="text-align: center;">
    <b-row v-if="!cdn.error" class="justify-content-around align-items-center">
      <b-col md="4"  cols="3" class="toobig">
        <span class="toobig" :title="cdn.OriginUrl">{{cdn.OriginUrl}}</span>
      </b-col>
      <b-col md="4"  cols="3" class="toobig">
        <b-row>
          <b-col cols="12">
              <strong class="toobig" style="color:#2F90B0;" :title="cdn.Hostnames[0].Value">https://{{cdn.Hostnames[0].Value}}</strong>
          </b-col>
        </b-row>
        <b-row style="margin-top: 5px;">
          <b-col cols="12">
              <b-button size="sm" variant="msstreamblue" @click="copyToClipboard('https://' + cdn.Hostnames[0].Value); showqk=true">
                  <font-awesome-icon icon="clone"></font-awesome-icon> 
              </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="2">
        <b-row>
            <b-col cols="12">
                {{Math.round(cdn.MonthlyCharges * 100)/100}} €
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                (10 €/{{$ml.get('TBunit')}})
            </b-col>
        </b-row>
      </b-col>
      <b-col  md="2" cols="4">
          <b-button variant="mswarning" size="sm" title="Purge cache" @click="purgeCDN(cdn)">
              <b-spinner small v-if="cdn._purgeLoading"></b-spinner>
              <span v-if="cdn._purgeLoading">&nbsp;</span>
              <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
          </b-button>
          &nbsp;
          <b-button variant="msstreamblue" size="sm" @click="selectedCDN = cdn; showModal('security')">
              <b-spinner small v-if="cdn._updateLoading"></b-spinner>
              <span v-if="cdn._updateLoading">&nbsp;</span>
              <font-awesome-icon :icon="['fas', 'lock']"></font-awesome-icon>
          </b-button>
          &nbsp;
          <b-button variant="quanteec" size="sm" @click="deleteCDN(cdn)">
              <b-spinner small v-if="cdn._deleteLoading"></b-spinner>
              <span v-if="cdn._deleteLoading">&nbsp;</span>
              X
          </b-button>
      </b-col>
    </b-row>
    <b-row class="justify-content-around" style="font-size: 0.7rem;">
            <b-col cols="auto" v-if="cdn.BlockedIps.length > 0" class="marginaltopsm">
                <span class="myBadge blockedBadge">{{$ml.get('cdnblockedips')}}:</span> {{cdn.BlockedIps.join(', ')}}
            </b-col>
            <b-col cols="auto" v-if="cdn.BlockedCountries.length > 0" class="marginaltopsm">
                <span class="myBadge blockedBadge">{{$ml.get('cdnblockedcountries')}}:</span> {{cdn.BlockedCountries.join(', ')}}
            </b-col>
            <b-col cols="auto" v-if="cdn.AllowedReferrers.length > 0" class="marginaltopsm">
                <span class="myBadge allowedBadge">{{$ml.get('cdnwhitelistedwebsites')}}:</span> {{cdn.AllowedReferrers.join(', ')}}
            </b-col>
            <b-col cols="auto" v-if="cdn.BlockedReferrers.length > 0" class="marginaltopsm">
                <span class="myBadge blockedBadge">{{$ml.get('cdnblacklistedwebsites')}}:</span> {{cdn.BlockedReferrers.join(', ')}}
            </b-col>
    </b-row>
      <hr v-if="!cdn.error">
  </div>
  <b-form @submit.prevent="postCDN">
      <b-row class="justify-content-around align-items-center" style="text-align:center;">
        <b-col md="4"  cols="3">
            <b-input type="text" v-model="newOrigin" placeholder="Your origin url" required></b-input>
        </b-col>
        <b-col md="4"  cols="3">
            <b-input type="text" v-model="newName" disabled></b-input>
        </b-col>
        <b-col cols="2">
            <strong>10 € / {{$ml.get('TBunit')}}</strong>
        </b-col>
        <b-col cols="2">
            <b-button variant="green" type="submit">{{$ml.get('addcdn')}}</b-button>
        </b-col>
      </b-row>
  </b-form>

<div v-if="cdns && cdns.length > 0" style="margin-top: 60px;">
  <p v-html="$ml.get('customcdnp1')"></p>
  <div class="marginaltop">
    <p style="margin-bottom: 20px;" v-html="$ml.get('customcdnp2')"></p>
    <code class="myCode">{{cdns[0].OriginUrl}}/videos/playlist.m3u8</code>
    <p style="margin: 20px 0px;" v-html="$ml.get('customcdnp3')"></p>
    <code class="myCode">https://{{cdns[0].Hostnames[0].Value}}/videos/playlist.m3u8</code>
  </div>
</div>
</div>

<b-modal ref="security" hide-footer title="CDN access configuration" @show="openModalAuthorization">
    <b-form>
        <!-- IP -->
      <b-row class="align-items-center justify-content-around">
        <b-col cols="auto">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('cdnblockedips')}}
        </b-col>
      </b-row>
      <p style="font-size:10px; margin-bottom:8px;margin-top:4px; text-align:center;" v-html="$ml.get('customcdnp4')"></p>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-12" element-id="tagsuIP" style="font-size:small"
          v-model="selectedCDN._unauthorizedIPsTags" placeholder="IP address + Enter"></tags-input>
      </b-row>
      <!-- Countries -->
      <b-row class="align-items-center justify-content-around">
        <b-col cols="auto">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('cdnblockedcountries')}}
        </b-col>
      </b-row>
      <p style="font-size:10px; margin-bottom:8px;margin-top:4px; text-align:center;" v-html="$ml.get('customcdnp5')"></p>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-12" element-id="tagsuIP" style="font-size:small"
          v-model="selectedCDN._unauthorizedCountriesTags" placeholder="Country code + Enter"></tags-input>
      </b-row>
      <!-- Referer -->
      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('cdnwhitelistedwebsites')}}
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">

        </b-col>
        <b-col cols="col-md-5">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('cdnblacklistedwebsites')}}
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('customcdnp6')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('customcdnp7')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaW"  style="font-size:small"
          v-model="selectedCDN._whitelistedWebsiteTags" placeholder="Website + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuW"  style="font-size:small"
          v-model="selectedCDN._blacklistedWebsiteTags" placeholder="Website + Enter"></tags-input>
      </b-row>

      <p style="color: #ba0000; text-align: center" v-html="$ml.get('customcdnp8')" ></p>

        <b-row class="justify-content-around">
            <b-col cols="auto">
                <b-button variant="msstreamblue" @click="updateCDN();hideModal('security')">{{$ml.get('Submit')}}</b-button>
            </b-col>
            <b-col cols="auto">
                <b-button variant="mswarning" @click="cancelUpdates();hideModal('security')">{{$ml.get('cancel')}}</b-button>
            </b-col>
        </b-row>  
    </b-form>
</b-modal>

<b-modal ref="copied" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('copied')}}</h3>
      </div>
      <p>{{$ml.get('selectedtextcopied')}}</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();hideModal('copied')">Ok</b-btn>
      </b-row>
  </b-modal>

  <b-modal ref="errorSomewhere" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('Error')}}
        </h4>
      </div>
      <p style="line-height: normal">
        {{errorMsg}}
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('errorSomewhere')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>

    <b-modal ref="purgeSuccess" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('Success')}}
        </h4>
      </div>
      <p style="line-height: normal">
        
      </p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-5 col-5"
          variant="quanteeclg"
          block
          @click="hideModal('purgeSuccess')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>
  
</div>
</template>

<script>
import CDNService from '@/services/cdn.service.js'
let cdnService = new CDNService();
export default {
  name: "CustomCDN",
  data: function () {
    return {
        clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1 ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
        cdns: [],
        newName: '',
        newOrigin: '',
        timeout: null,
        selectedCDN: {},
        isLoading: false,
        errorMsg: '',
    };
  },
  mounted: function () {
      this.getCDNs();
  },
  methods: {
    getNextName() {
        let number = 0;
        let nameRgex = new RegExp('.+-[0-9]+-quanteec', '');
        this.cdns.forEach(cdn => {
            if (nameRgex.test(cdn.Name)) {
                let name = cdn.Name;
                let n = +name.replace(this.clientView, '').replace('-','').replace('-quanteec', '');
                number = Math.max(number, n);
            }
        })
        number++;
        this.newName = `${this.clientView}-${number}-quanteec`;
    },
    getCDNs() {
        this.isLoading = true;
        cdnService.getCDNs(this.$auth.token())
        .then(cdns => {
            this.isLoading = false;
            this.cdns = cdns;
            this.getNextName();
        }).catch(err => {
            this.isLoading = false;
            this.errorMsg = "Can not get the CDNs. Please retry later or contact Quanteec at : contact@quanteec.com";
            this.showModal('errorSomewhere');
            console.log(err);
        })
    },
    postCDN() {
        console.log(this.newName, this.newOrigin)
        this.isLoading = true;
        cdnService.postCDN(this.newName, this.newOrigin, this.$auth.token())
        .then(cdn => {
            this.isLoading = false;
            this.cdns.push(cdn);
            this.getNextName();
            this.newOrigin = '';
        }).catch(err => {
            this.isLoading = false;
            this.errorMsg = "Can not create the new CDN redirect. Please verify the adress of your origin, retry later or contact Quanteec at : contact@quanteec.com";
            this.showModal('errorSomewhere');
            console.log(err);
        })
    },
    deleteCDN(cdn) {
        cdn._deleteLoading = true;
        this.cdns = this.cdns.splice(0);
        cdnService.deleteCDN(cdn.Id, this.$auth.token())
        .then(() => {
            cdn._deleteLoading = false;
            this.cdns = this.cdns.splice(0);
            this.getCDNs();
        }).catch(err => {
            cdn._deleteLoading = false;
            this.cdns = this.cdns.splice(0);
            this.errorMsg = "Can not delete the CDN entry. Please retry later or contact Quanteec at : contact@quanteec.com";
            this.showModal('errorSomewhere');
            console.log(err);
        })
    },
    purgeCDN(cdn) {
        cdn._purgeLoading = true;
        this.cdns = this.cdns.splice(0);
        cdnService.purgeCDN(cdn.Id, this.$auth.token())
        .then(() => {
            cdn._purgeLoading = false;
            this.cdns = this.cdns.splice(0);
            this.showModal('purgeSuccess');
        }).catch(err => {
            cdn._purgeLoading = false;
            this.cdns = this.cdns.splice(0);
            this.errorMsg = "Can not purge the cache of the CDN entry. Please retry later or contact Quanteec at : contact@quanteec.com";
            this.showModal('errorSomewhere');
            console.log(err);
        })
    },
    copyToClipboard(text) {
        this.cleanMyTimeout();
        this.$copyText(text);
        this.showModal("copied");
        this.timeout = setTimeout(this.hideModal, 1.5 * 1000, 'copied');
    },
    showModal(modal) {
        this.$refs[modal].show();
    },
    hideModal(modal) {
        this.$refs[modal].hide();
    },
    cleanMyTimeout() {
        try {
            clearTimeout(this.timeout);
        } catch(err) {}
    },
     openModalAuthorization()
    {
      this.selectedCDN._unauthorizedIPs = this.selectedCDN.BlockedIps;
      this.selectedCDN._unauthorizedCountries = this.selectedCDN.BlockedCountries;
      this.selectedCDN._whitelistedWebsite = this.selectedCDN.AllowedReferrers;
      this.selectedCDN._blacklistedWebsite = this.selectedCDN.BlockedReferrers;

      this.selectedCDN._unauthorizedIPsTags = this.selectedCDN.BlockedIps.map(x => {return {key: x, value: x}});
      this.selectedCDN._unauthorizedCountriesTags = this.selectedCDN.BlockedCountries.map(x => {return {key: x, value: x}});
      this.selectedCDN._whitelistedWebsiteTags = this.selectedCDN.AllowedReferrers.map(x => {return {key: x, value: x}});
      this.selectedCDN._blacklistedWebsiteTags = this.selectedCDN.BlockedReferrers.map(x => {return {key: x, value: x}});

    },
    updateUnauthorizedCountries()
    {
      this.selectedCDN._unauthorizedCountries = this.selectedCDN._unauthorizedCountriesTags.map(x => x.value);
      this.modifyUnauthorizedCountries = false;
    },
    cancelUnauthorizedCountries()
    {
      this.selectedCDN._unauthorizedCountriesTags = this.selectedCDN._unauthorizedCountries.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedCountries = false;
    },
    updateWhitelistedWebsites() {
        this.selectedCDN._whitelistedWebsite = this.selectedCDN._whitelistedWebsiteTags.map(x=>x.value);
        this.modifyWhitelistedWebsites = false;
    },
    cancelWhitelistedWebsites() {
        this.selectedCDN._whitelistedWebsiteTags = this.selectedCDN._whitelistedWebsite.map(x => {return {key: x, value: x}});
        this.modifyWhitelistedWebsites = false;
    },
    updateBlacklistedWebsites() {
        this.selectedCDN._blacklistedWebsite = this.selectedCDN._blacklistedWebsiteTags.map(x=>x.value);
        this.modifyBlacklistedWebsites = false;
    },
    cancelBlacklistedWebsites() {
        this.selectedCDN._blacklistedWebsiteTags = this.selectedCDN._blacklistedWebsite.map(x => {return {key: x, value: x}});
        this.modifyBlacklistedWebsites = false;
    },
    updateUnauthorizedIPs()
    {
      this.selectedCDN._unauthorizedIPs = this.selectedCDN._unauthorizedIPsTags.map(x => x.value);
      this.modifyUnauthorizedIPs = false;
    },
    cancelUnauthorizedIPs()
    {
      this.selectedCDN.unauthorizedIPsTags = this.selectedCDN._unauthorizedIPs.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedIPs = false;
    },
    cancelUpdates() {
        this.cancelUnauthorizedIPs();
        this.cancelUnauthorizedCountries();
        this.cancelWhitelistedWebsites();
        this.cancelBlacklistedWebsites();

    },
    updateCDN() {
        this.updateUnauthorizedIPs();
        this.updateUnauthorizedCountries();
        this.updateWhitelistedWebsites();
        this.updateBlacklistedWebsites();

        let data = {
            BlockedIps: this.selectedCDN._unauthorizedIPs,
            BlockedCountries: this.selectedCDN._unauthorizedCountries,
            AllowedReferrers: this.selectedCDN._whitelistedWebsite,
            BlockedReferrers: this.selectedCDN._blacklistedWebsite
        }
        this.selectedCDN._updateLoading = true;
        this.cdns = this.cdns.splice(0);

        cdnService.updateCDN(this.selectedCDN.Id, data, this.$auth.token()).then(() => {
            this.selectedCDN._updateLoading = false;
            this.cdns = this.cdns.splice(0);
            this.getCDNs();
        }).catch(err => {
            this.selectedCDN._updateLoading = false;
            this.cdns = this.cdns.splice(0);
            this.errorMsg = "Can not update the CDN entry. Please retry later or contact Quanteec at : contact@quanteec.com";
            this.showModal('errorSomewhere');
            this.cancelUpdates();
        })
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.myCode {
    border: solid 1px darkgrey;
    border-radius: 5px;
    background-color:rgba(0,0,0,0.1);
    color: #113448;
    padding: 5px 5px;
}

.toobig {
    text-overflow: ellipsis;
    overflow: hidden; 
    white-space: nowrap;
}

.blockedBadge {
    background-color: rgba(#ba0000, 0.2);
}

.allowedBadge {
    background-color: rgba(#14BF98, 0.2);
}

.myBadge {
    padding-right: 0.6em;
    padding-left: 0.6em;
    border-radius: 10em;
}

</style>
